import { AfterViewChecked, ChangeDetectorRef, Component, inject } from '@angular/core';
import { ZiroFieldComponentConfig } from '../../../forms/ziro-forms-models';
import { ZiroFieldAbstractDirective } from '../../../forms/ziro-field-abstract.directive';
import { UniqueIdService } from '../../../shared/services/unique-id.service';
import { NgModel } from '@angular/forms';

export interface CallForwardField {
  destination: string;
  forwardToVoicemail: boolean;
}

export class ZiroCallForwardConfig extends ZiroFieldComponentConfig {
  constructor(
    public config: {
      hasVoicemail?: boolean;
      isUnityServerConfigured?: boolean;
      hideWarning?: boolean;
    },
  ) {
    super();
  }
}

@Component({
  selector: 'ziro-directory-number-call-forward',
  templateUrl: './call-forward.component.html',
  styleUrls: ['./call-forward.component.scss'],
  providers: [{ provide: ZiroFieldAbstractDirective, useExisting: ZiroCallForwardComponent }],
  standalone: false,
})
export class ZiroCallForwardComponent
  extends ZiroFieldAbstractDirective<CallForwardField, CallForwardField, ZiroCallForwardConfig>
  implements AfterViewChecked
{
  private uniqueIdService = inject(UniqueIdService);
  private changeDetection = inject(ChangeDetectorRef);

  hasVoicemail: boolean;
  isUnityServerConfigured: boolean;
  uniqueRadioId: string;
  hideWarning = false;

  constructor() {
    super();
    const uniqueIdService = this.uniqueIdService;

    this.uniqueRadioId = uniqueIdService.getUniqueId();
  }

  applyComponentConfig: ({ config }: ZiroCallForwardConfig) => void = ({ config }: ZiroCallForwardConfig) => {
    this.hasVoicemail = config.hasVoicemail;
    this.isUnityServerConfigured = config.isUnityServerConfigured;
    this.hideWarning = config.hideWarning;
  };

  onChange($event: boolean | string, ngModelDir: NgModel): void {
    if (typeof $event === 'boolean') {
      return this.updateStateAndSelf({ ...this.fieldData, forwardToVoicemail: $event }, ngModelDir);
    }
    this.updateStateAndSelf({ ...this.fieldData, destination: $event }, ngModelDir);
  }

  showWarningMessage(): boolean {
    return !this.hasVoicemail && this.isUnityServerConfigured && this.fieldData.forwardToVoicemail && !this.hideWarning;
  }

  showErrorMessage(): boolean {
    if (this.fieldData.forwardToVoicemail) {
      return false;
    }

    const val = this.fieldData.destination;
    return val.includes('@') ? !/^.*$/.test(val) : !/^[PpFfCc0-9#*+,]*$/.test(val);
  }

  ngAfterViewChecked(): void {
    this.changeDetection.detectChanges();
  }
}
